import { i18nLike } from "#web/services/i18nLike";
import { Badge } from "@shopify/polaris";

import { LeakedCode } from "./_models/leakedCode";
import { en } from "./LeakedCodesIndexTable/translations";

export const LeakStatusBadge = ({ leakedCode }: { leakedCode: LeakedCode }) => {
  const t = i18nLike(en);

  return leakedCode.isCurrentlyLeaked ? (
    <Badge tone="warning">{t("leakStatus.leaked")}</Badge>
  ) : (
    <Badge>{t("leakStatus.notLeaked")}</Badge>
  );
};
